/**
 * The build this bundle was made from (e.g. "20261016T0503-bd10f93": UTC
 * build time, then the commit). Baked in by vite.config.ts, which also writes
 * it to /version.json. Under `vite dev` the commit part is "local".
 */
export const APP_BUILD: string = import.meta.env.VITE_APP_BUILD
